module.exports = __webpack_public_path__ + "static/img/logo_dark.69389830.png";